import React, {PureComponent} from 'react';
import styled from 'styled-components';
import {NotificationManager} from 'react-notifications';

import * as api from '../lib/api';
import Button from './Button';
import Input from './Input';

class TimeZonePicker extends PureComponent {
  state = {
    timeZones: null,
    canDetectTimeZone: false
  };
  
  async componentDidMount() {
    const timeZones = await getTimeZones();
    const browserTimeZone = getBrowserTimeZone();
    const canDetectTimeZone = timeZones.filter(tz => tz.id === browserTimeZone).length === 1;
    
    this.setState({timeZones, canDetectTimeZone});
  }

  handleDetect = () => {
    const {onSelect} = this.props;
    const browserTimeZone = getBrowserTimeZone();

    onSelect(browserTimeZone);
    NotificationManager.success(`We've detected that your timezone is ${browserTimeZone.replace('_', ' ')}`);
  }
  
  render() {
    const {selected, onSelect, ...inputProps} = this.props;
    const {timeZones, canDetectTimeZone} = this.state;

    if (!timeZones) {
      return <Input {...inputProps} readOnly placeholder="Loading timezones..." />;
    }

    return (
      <Container>
        <Input
          {...inputProps}
          value={selected}
          onChange={e => onSelect(e.target.value)}
          type="select">
          {timeZones.map(tz => (
            <option key={tz.id} value={tz.id}>{tz.name}</option>
          ))}
        </Input>
        {canDetectTimeZone && (
          <ButtonContainer>
            <Button tertiary onClick={this.handleDetect}>Detect My Timezone</Button>
          </ButtonContainer>
        )}
      </Container>
    );
  }
}

let timeZoneCache = null;

async function getTimeZones() {
  if (timeZoneCache === null) {
    timeZoneCache = api.getTimeZones();
  }

  return timeZoneCache;
}

function getBrowserTimeZone() {
  // Intl is supported in all major browsers.
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
}

const Container = styled.div`
  display: flex;
  align-items: flex-end;
`;

const ButtonContainer = styled.div`
  margin-left: 0.5rem;
`;

export default TimeZonePicker;